import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import resources from "i18n/locales/resources";
import { translationsUrl } from "utils/env";

const LANGUAGE_STORAGE_KEY = "fw_user_language";

const getSavedLanguage = () => {
  return localStorage.getItem(LANGUAGE_STORAGE_KEY) || "en";
};

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    resources,
    partialBundledLanguages: true,
    lng: getSavedLanguage(),
    fallbackLng: "en",
    ns: ["web-common", "onboarding-disabled-message"],
    defaultNS: "web-common",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      crossDomain: true,
      loadPath: `${translationsUrl}/{{lng}}/{{ns}}.json`,
    },
  });

export { LANGUAGE_STORAGE_KEY };
export default i18n;
